module.exports = __webpack_public_path__ + "static/img/2.0558ba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/17/2.png
// module id = TwyK
// module chunks = 2